import { create } from "zustand";

interface ShellState {
  /** A basket bar is on screen, so the floating Book button steps aside for it. */
  basketOpen: boolean;
  setBasketOpen: (open: boolean) => void;
  /** A full-size Book button is on screen (the home page's hero), so the floating one would only cover it. */
  inlineBookVisible: boolean;
  setInlineBookVisible: (visible: boolean) => void;
}

export const useShellStore = create<ShellState>()((set) => ({
  basketOpen: false,
  setBasketOpen: (basketOpen) => set({ basketOpen }),
  inlineBookVisible: false,
  setInlineBookVisible: (inlineBookVisible) => set({ inlineBookVisible }),
}));
